<!-- // todo: migrate to iota-modal -->
<div class="modal-box w-[50vw] max-w-full max-h-[70vh] flex flex-col p-4 resize" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
    <div class="flex flex-row items-start justify-between border-b-2 pb-1" cdkDragHandle>
        <div class="flex flex-col gap-1 max-w-1/3">
            <span class="font-bold text-lg whitespace-pre-wrap break-words" i18n>Mail delivery</span>
        </div>

        <button class="btn btn-ghost btn-circle" mat-dialog-close>
            <iota-icon icon="x-mark" size="1.5"></iota-icon>
        </button>
    </div>

    <div class="form-control w-full">
        <label class="label">
            <span class="label-text" i18n>Recipient</span>
        </label>
        <input type="text" i18n-placeholder placeholder="Recipient" class="input input-bordered w-full" [(ngModel)]="message.to" />
    </div>

    <div class="form-control w-full">
        <label class="label">
            <span class="label-text" i18n>Email Preview</span>
        </label>
        <div class="rounded-lg bg-white border border-iota-outline p-6 text-sm leading-normal">
            <p class="font-bold mb-5"><span i18n>Subject:</span> {{ message.subject }}</p>
            <div [innerHTML]="previewText | safeHtmlBypass"></div>

            <div class="mt-4 flex items-center gap-4">
                <img class="w-[120px] h-auto block" src="https://www.inh.eu/logo-chaemp-email-signature/" alt="chæmp Logo" />
                <div class="leading-tight">
                    <p class="font-bold italic">Support-Team</p>
                    <p class="italic">Customer Care</p>
                </div>
            </div>

            <div class="mt-4 text-sm leading-normal">
                <p>INH GmbH · innovative health management</p>
                <p>Viehmarktplatz 14 · 54290 Trier · Deutschlanddd</p>
                <p class="mt-2"><b>T</b>&nbsp;+49 651 93740-0</p>
                <a href="mailto:health&#64;inh.eu" class="text-iota-regulators underline block">health&#64;inh.eu</a>
                <a href="https://www.inh.eu" class="text-iota-regulators underline block">www.inh.eu</a>
                <p class="mt-2 font-bold italic text-iota-inh-green">work healthy. be healthy.</p>
                <p class="text-xs text-gray-400">Sitz: Trier · Amtsgericht Wittlich · HRB 45254</p>
                <p class="text-xs text-gray-400">Geschäftsführer: Michael Reiszner</p>
            </div>
        </div>
    </div>

    <p class="label-text mt-2" i18n>Attachments:</p>

    <ul class="list-inside list-disc">
        <li *ngFor="let attachment of message.attachments">{{ attachment.name }}</li>
    </ul>

    <div class="flex flex-row justify-between items-center mt-auto pt-2 border-t-2">
        <button class="btn btn-ghost" [ngClass]="{ loading: (sending$ | ngrxPush) }" mat-dialog-close i18n>Cancel</button>

        <div
            class="alert alert-error shadow-lg w-fit"
            *ngIf="!(sending$ | ngrxPush) && !(sendSuccess$ | ngrxPush) && (sendFailure$ | ngrxPush)"
        >
            <div>
                <iota-icon icon="exclamation-triangle" size="1.5"></iota-icon>
                <span i18n>An error occurred while sending the email.</span>
            </div>
        </div>

        <button class="btn btn-primary" [ngClass]="{ loading: (sending$ | ngrxPush) }" [disabled]="isInvalid()" (click)="sendMail()" i18n>
            Send
        </button>
    </div>
</div>
